// Configuración compartida por la aplicación y su service worker.
// Mantenerla en un módulo puro evita duplicar valores y permite que Workbox
// empaquete Firebase Messaging sin depender de scripts CDN en segundo plano.
export const configuracionFirebase = {
  apiKey:            'AIzaSyDS_3Uze577pQWIFlWwvk56nZ6-1wjZblU',
  authDomain:        'gestionnorgym.firebaseapp.com',
  projectId:         'gestionnorgym',
  storageBucket:     'gestionnorgym.appspot.com',
  messagingSenderId: '683214502199',
  appId:             '1:683214502199:web:4b99bbec62e80159ef82b2',
  measurementId:     'G-Q7JBYRFXRD'
};

export default configuracionFirebase;
